import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/TextArea';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { bannerWhatsNewPut } from '../../api';
import Loading from 'components/Loading';
import { messageSentNotice } from '../UI/Notifications';
import { useHistory } from "react-router-dom";
import axios from 'axios';

const UpdateWhatsNewMessage = () => {
  const { register, handleSubmit, errors } = useForm();
  const [inputValue , setInputValue] = useState();
  const [loading, setLoading] = useState(false);

  let history = useHistory();

  const onChangeHandler = (value) => {
    setInputValue(value.value)
  }

  const onSubmit = data => {
    setLoading(true);
    
    bannerWhatsNewPut(data)
    .then(response => {
      setLoading(false)
      messageSentNotice("Success");
      setInputValue('');
     })
     .catch(error => {
       console.log(error);
     })
  }

  const handleEsc = useCallback((e) => {
     if(e.keyCode === 27) {
      history.goBack();
     }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleEsc, false);

    return () => {
      document.removeEventListener("keydown", handleEsc, false);
    };
  }, []);

  return (
    <>
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5 text-center">
              What's New?
            </h3>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <label htmlFor="body">Update the What's New message below</label>
                <TextArea 
                  name="body" 
                  register={register()}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </fieldset>
              <div className="d-flex align-items-center">
                <button
                  className="btnSizes filledBtn"
                  type="submit"
                >
                  Update
                </button>
                <a 
                  className="btnSizes transparentBtn border-0 ml-5" 
                  onClick={() => history.goBack()}
                >
                  Cancel
                </a>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </section>  
    { loading && <Loading />}
    </>
  )
}

export default UpdateWhatsNewMessage;